/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Dyna ERP API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminResetPasswordIn,
  ChangePasswordIn,
  ForgotPasswordIn,
  ListOrgUsersParams,
  LoginIn,
  LoginOut,
  MessageOut,
  ResetPasswordIn,
  RoleSummary,
  SessionOut,
  UserAdminListItem,
  UserAdminUpdateIn,
  UserBankDetailsIn,
  UserBankDetailsOut,
  WhoamiResponse
} from '../model';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Login
 */
export const login = (
    loginIn: LoginIn,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<LoginOut>(
      {url: `/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginIn, signal
    },
      options);
    }




export const getLoginMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginIn}, TContext> => {

const mutationKey = ['login'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, {data: LoginIn}> = (props) => {
          const {data} = props ?? {};

          return  login(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
    export type LoginMutationBody = LoginIn
    export type LoginMutationError = unknown

    /**
 * @summary Login
 */
export const useLogin = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof login>>,
        TError,
        {data: LoginIn},
        TContext
      > => {
      return useMutation(getLoginMutationOptions(options), queryClient);
    }
    /**
 * @summary Forgot Password
 */
export const forgotPassword = (
    forgotPasswordIn: ForgotPasswordIn,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<MessageOut>(
      {url: `/auth/forgot-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: forgotPasswordIn, signal
    },
      options);
    }




export const getForgotPasswordMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,{data: ForgotPasswordIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,{data: ForgotPasswordIn}, TContext> => {

const mutationKey = ['forgotPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof forgotPassword>>, {data: ForgotPasswordIn}> = (props) => {
          const {data} = props ?? {};

          return  forgotPassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ForgotPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof forgotPassword>>>
    export type ForgotPasswordMutationBody = ForgotPasswordIn
    export type ForgotPasswordMutationError = unknown

    /**
 * @summary Forgot Password
 */
export const useForgotPassword = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,{data: ForgotPasswordIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof forgotPassword>>,
        TError,
        {data: ForgotPasswordIn},
        TContext
      > => {
      return useMutation(getForgotPasswordMutationOptions(options), queryClient);
    }
    /**
 * @summary Reset Password
 */
export const resetPassword = (
    resetPasswordIn: ResetPasswordIn,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<MessageOut>(
      {url: `/auth/reset-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resetPasswordIn, signal
    },
      options);
    }




export const getResetPasswordMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordIn}, TContext> => {

const mutationKey = ['resetPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPassword>>, {data: ResetPasswordIn}> = (props) => {
          const {data} = props ?? {};

          return  resetPassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetPassword>>>
    export type ResetPasswordMutationBody = ResetPasswordIn
    export type ResetPasswordMutationError = unknown

    /**
 * @summary Reset Password
 */
export const useResetPassword = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetPassword>>,
        TError,
        {data: ResetPasswordIn},
        TContext
      > => {
      return useMutation(getResetPasswordMutationOptions(options), queryClient);
    }
    /**
 * @summary Change Password Endpoint
 */
export const changePassword = (
    changePasswordIn: ChangePasswordIn,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<MessageOut>(
      {url: `/auth/change-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: changePasswordIn, signal
    },
      options);
    }




export const getChangePasswordMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{data: ChangePasswordIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{data: ChangePasswordIn}, TContext> => {

const mutationKey = ['changePassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changePassword>>, {data: ChangePasswordIn}> = (props) => {
          const {data} = props ?? {};

          return  changePassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof changePassword>>>
    export type ChangePasswordMutationBody = ChangePasswordIn
    export type ChangePasswordMutationError = unknown

    /**
 * @summary Change Password Endpoint
 */
export const useChangePassword = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{data: ChangePasswordIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changePassword>>,
        TError,
        {data: ChangePasswordIn},
        TContext
      > => {
      return useMutation(getChangePasswordMutationOptions(options), queryClient);
    }
    /**
 * @summary Logout
 */
export const logout = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<MessageOut>(
      {url: `/auth/logout`, method: 'POST', signal
    },
      options);
    }




export const getLogoutMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext> => {

const mutationKey = ['logout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logout>>, void> = () => {


          return  logout(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>

    export type LogoutMutationError = unknown

    /**
 * @summary Logout
 */
export const useLogout = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof logout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutMutationOptions(options), queryClient);
    }
    /**
 * @summary Logout All
 */
export const logoutAll = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<MessageOut>(
      {url: `/auth/logout-all`, method: 'POST', signal
    },
      options);
    }




export const getLogoutAllMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutAll>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof logoutAll>>, TError,void, TContext> => {

const mutationKey = ['logoutAll'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutAll>>, void> = () => {


          return  logoutAll(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutAllMutationResult = NonNullable<Awaited<ReturnType<typeof logoutAll>>>

    export type LogoutAllMutationError = unknown

    /**
 * @summary Logout All
 */
export const useLogoutAll = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutAll>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof logoutAll>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutAllMutationOptions(options), queryClient);
    }
    /**
 * @summary Whoami Endpoint
 */
export const whoami = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<WhoamiResponse>(
      {url: `/auth/whoami`, method: 'GET', signal
    },
      options);
    }




export const getWhoamiQueryKey = () => {
    return [
    `/auth/whoami`
    ] as const;
    }


export const getWhoamiQueryOptions = <TData = Awaited<ReturnType<typeof whoami>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof whoami>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWhoamiQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof whoami>>> = ({ signal }) => whoami(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof whoami>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WhoamiQueryResult = NonNullable<Awaited<ReturnType<typeof whoami>>>
export type WhoamiQueryError = unknown


export function useWhoami<TData = Awaited<ReturnType<typeof whoami>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof whoami>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof whoami>>,
          TError,
          Awaited<ReturnType<typeof whoami>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWhoami<TData = Awaited<ReturnType<typeof whoami>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof whoami>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof whoami>>,
          TError,
          Awaited<ReturnType<typeof whoami>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWhoami<TData = Awaited<ReturnType<typeof whoami>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof whoami>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Whoami Endpoint
 */

export function useWhoami<TData = Awaited<ReturnType<typeof whoami>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof whoami>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWhoamiQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary List Sessions
 */
export const listSessions = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SessionOut[]>(
      {url: `/auth/sessions`, method: 'GET', signal
    },
      options);
    }




export const getListSessionsQueryKey = () => {
    return [
    `/auth/sessions`
    ] as const;
    }


export const getListSessionsQueryOptions = <TData = Awaited<ReturnType<typeof listSessions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSessionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSessions>>> = ({ signal }) => listSessions(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof listSessions>>>
export type ListSessionsQueryError = unknown


export function useListSessions<TData = Awaited<ReturnType<typeof listSessions>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSessions>>,
          TError,
          Awaited<ReturnType<typeof listSessions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSessions<TData = Awaited<ReturnType<typeof listSessions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSessions>>,
          TError,
          Awaited<ReturnType<typeof listSessions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSessions<TData = Awaited<ReturnType<typeof listSessions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Sessions
 */

export function useListSessions<TData = Awaited<ReturnType<typeof listSessions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSessionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Revoke Session Endpoint
 */
export const revokeSession = (
    sessionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/auth/sessions/${sessionId}`, method: 'DELETE', signal
    },
      options);
    }




export const getRevokeSessionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeSession>>, TError,{sessionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeSession>>, TError,{sessionId: string}, TContext> => {

const mutationKey = ['revokeSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeSession>>, {sessionId: string}> = (props) => {
          const {sessionId} = props ?? {};

          return  revokeSession(sessionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeSessionMutationResult = NonNullable<Awaited<ReturnType<typeof revokeSession>>>

    export type RevokeSessionMutationError = unknown

    /**
 * @summary Revoke Session Endpoint
 */
export const useRevokeSession = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeSession>>, TError,{sessionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeSession>>,
        TError,
        {sessionId: string},
        TContext
      > => {
      return useMutation(getRevokeSessionMutationOptions(options), queryClient);
    }
    /**
 * Org-scoped roles for pickers (e.g. the approval-chain editor).
 *
 * Gated on ``roles:view``. Gated INLINE rather than via
 * ``@requires_permission`` because this router uses
 * ``from __future__ import annotations``, which the decorator's
 * request-time ``model_rebuild`` doesn't tolerate (see the approvals
 * router docstring for the same constraint). Super-admins bypass, same
 * as the decorator.
 * @summary List Role Summaries Endpoint
 */
export const listRoleSummaries = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RoleSummary[]>(
      {url: `/auth/roles/`, method: 'GET', signal
    },
      options);
    }




export const getListRoleSummariesQueryKey = () => {
    return [
    `/auth/roles/`
    ] as const;
    }


export const getListRoleSummariesQueryOptions = <TData = Awaited<ReturnType<typeof listRoleSummaries>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoleSummaries>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRoleSummariesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRoleSummaries>>> = ({ signal }) => listRoleSummaries(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRoleSummaries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRoleSummariesQueryResult = NonNullable<Awaited<ReturnType<typeof listRoleSummaries>>>
export type ListRoleSummariesQueryError = unknown


export function useListRoleSummaries<TData = Awaited<ReturnType<typeof listRoleSummaries>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoleSummaries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRoleSummaries>>,
          TError,
          Awaited<ReturnType<typeof listRoleSummaries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRoleSummaries<TData = Awaited<ReturnType<typeof listRoleSummaries>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoleSummaries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRoleSummaries>>,
          TError,
          Awaited<ReturnType<typeof listRoleSummaries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRoleSummaries<TData = Awaited<ReturnType<typeof listRoleSummaries>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoleSummaries>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Role Summaries Endpoint
 */

export function useListRoleSummaries<TData = Awaited<ReturnType<typeof listRoleSummaries>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoleSummaries>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRoleSummariesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * The caller's own payee bank details (masked). Identity-scoped to
 * ``request.auth`` -- no permission required, no other user is readable.
 * @summary Get My Bank Details Endpoint
 */
export const getMyBankDetails = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserBankDetailsOut>(
      {url: `/auth/me/bank-details`, method: 'GET', signal
    },
      options);
    }




export const getGetMyBankDetailsQueryKey = () => {
    return [
    `/auth/me/bank-details`
    ] as const;
    }


export const getGetMyBankDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getMyBankDetails>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyBankDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyBankDetailsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyBankDetails>>> = ({ signal }) => getMyBankDetails(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyBankDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyBankDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyBankDetails>>>
export type GetMyBankDetailsQueryError = unknown


export function useGetMyBankDetails<TData = Awaited<ReturnType<typeof getMyBankDetails>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyBankDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyBankDetails>>,
          TError,
          Awaited<ReturnType<typeof getMyBankDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyBankDetails<TData = Awaited<ReturnType<typeof getMyBankDetails>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyBankDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyBankDetails>>,
          TError,
          Awaited<ReturnType<typeof getMyBankDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyBankDetails<TData = Awaited<ReturnType<typeof getMyBankDetails>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyBankDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Bank Details Endpoint
 */

export function useGetMyBankDetails<TData = Awaited<ReturnType<typeof getMyBankDetails>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyBankDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyBankDetailsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Org users + their bank-details status, for admin and assignment pickers.
 *
 * Gated INLINE on ``users:view`` (this router uses ``from __future__ import
 * annotations``; see ``list_role_summaries`` for why the decorator can't be used).
 * Org-scoped; super-admins see every org.
 *
 * ``?role=`` narrows to holders of that role by NAME, case-insensitively --
 * used by pickers that only offer one role (a project's assigned manager).
 * Filtering by name keeps this a single request: resolving an id would mean
 * calling ``GET /roles/``, which needs ``roles:view`` on top of the
 * ``users:view`` already required here. An unknown name returns an empty
 * list, since roles are org data and needn't exist in every environment.
 *
 * ``?exclude_external=true`` drops client-portal users, for a picker that is
 * choosing staff -- the subcategory approver picker, where a client contact
 * could never be saved. Off by default, so the admin user list still shows
 * every account.
 * @summary List Org Users Endpoint
 */
export const listOrgUsers = (
    params?: ListOrgUsersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserAdminListItem[]>(
      {url: `/auth/users/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListOrgUsersQueryKey = (params?: ListOrgUsersParams,) => {
    return [
    `/auth/users/`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOrgUsersQueryOptions = <TData = Awaited<ReturnType<typeof listOrgUsers>>, TError = unknown>(params?: ListOrgUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrgUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrgUsers>>> = ({ signal }) => listOrgUsers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrgUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrgUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listOrgUsers>>>
export type ListOrgUsersQueryError = unknown


export function useListOrgUsers<TData = Awaited<ReturnType<typeof listOrgUsers>>, TError = unknown>(
 params: undefined |  ListOrgUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrgUsers>>,
          TError,
          Awaited<ReturnType<typeof listOrgUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrgUsers<TData = Awaited<ReturnType<typeof listOrgUsers>>, TError = unknown>(
 params?: ListOrgUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrgUsers>>,
          TError,
          Awaited<ReturnType<typeof listOrgUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrgUsers<TData = Awaited<ReturnType<typeof listOrgUsers>>, TError = unknown>(
 params?: ListOrgUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Org Users Endpoint
 */

export function useListOrgUsers<TData = Awaited<ReturnType<typeof listOrgUsers>>, TError = unknown>(
 params?: ListOrgUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOrgUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A user's masked bank details, for an admin. Gated INLINE on ``users:view``.
 * @summary Get User Bank Details Admin Endpoint
 */
export const getUserBankDetailsAdmin = (
    userId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserBankDetailsOut>(
      {url: `/auth/users/${userId}/bank-details`, method: 'GET', signal
    },
      options);
    }




export const getGetUserBankDetailsAdminQueryKey = (userId: string,) => {
    return [
    `/auth/users/${userId}/bank-details`
    ] as const;
    }


export const getGetUserBankDetailsAdminQueryOptions = <TData = Awaited<ReturnType<typeof getUserBankDetailsAdmin>>, TError = unknown>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBankDetailsAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserBankDetailsAdminQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserBankDetailsAdmin>>> = ({ signal }) => getUserBankDetailsAdmin(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserBankDetailsAdmin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserBankDetailsAdminQueryResult = NonNullable<Awaited<ReturnType<typeof getUserBankDetailsAdmin>>>
export type GetUserBankDetailsAdminQueryError = unknown


export function useGetUserBankDetailsAdmin<TData = Awaited<ReturnType<typeof getUserBankDetailsAdmin>>, TError = unknown>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBankDetailsAdmin>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserBankDetailsAdmin>>,
          TError,
          Awaited<ReturnType<typeof getUserBankDetailsAdmin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserBankDetailsAdmin<TData = Awaited<ReturnType<typeof getUserBankDetailsAdmin>>, TError = unknown>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBankDetailsAdmin>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserBankDetailsAdmin>>,
          TError,
          Awaited<ReturnType<typeof getUserBankDetailsAdmin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserBankDetailsAdmin<TData = Awaited<ReturnType<typeof getUserBankDetailsAdmin>>, TError = unknown>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBankDetailsAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get User Bank Details Admin Endpoint
 */

export function useGetUserBankDetailsAdmin<TData = Awaited<ReturnType<typeof getUserBankDetailsAdmin>>, TError = unknown>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBankDetailsAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserBankDetailsAdminQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Set or correct a user's payee bank details (admin/finance).
 *
 * Gated INLINE on ``users:edit``. Users cannot edit their own -- this is the
 * only write path. Org-scope check + audit-log write live in the service.
 * @summary Set User Bank Details Admin Endpoint
 */
export const setUserBankDetailsAdmin = (
    userId: string,
    userBankDetailsIn: UserBankDetailsIn,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserBankDetailsOut>(
      {url: `/auth/users/${userId}/bank-details`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userBankDetailsIn, signal
    },
      options);
    }




export const getSetUserBankDetailsAdminMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setUserBankDetailsAdmin>>, TError,{userId: string;data: UserBankDetailsIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setUserBankDetailsAdmin>>, TError,{userId: string;data: UserBankDetailsIn}, TContext> => {

const mutationKey = ['setUserBankDetailsAdmin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setUserBankDetailsAdmin>>, {userId: string;data: UserBankDetailsIn}> = (props) => {
          const {userId,data} = props ?? {};

          return  setUserBankDetailsAdmin(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetUserBankDetailsAdminMutationResult = NonNullable<Awaited<ReturnType<typeof setUserBankDetailsAdmin>>>
    export type SetUserBankDetailsAdminMutationBody = UserBankDetailsIn
    export type SetUserBankDetailsAdminMutationError = unknown

    /**
 * @summary Set User Bank Details Admin Endpoint
 */
export const useSetUserBankDetailsAdmin = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setUserBankDetailsAdmin>>, TError,{userId: string;data: UserBankDetailsIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setUserBankDetailsAdmin>>,
        TError,
        {userId: string;data: UserBankDetailsIn},
        TContext
      > => {
      return useMutation(getSetUserBankDetailsAdminMutationOptions(options), queryClient);
    }
    /**
 * Admin update of a user's account fields (department).
 *
 * Gated INLINE on ``users:edit``. Org-scope check + audit-log write live in
 * the service. Advances stamp their ``department`` from the requester's value.
 * @summary Update User Admin Endpoint
 */
export const updateUserAdmin = (
    userId: string,
    userAdminUpdateIn: UserAdminUpdateIn,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<MessageOut>(
      {url: `/auth/users/${userId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userAdminUpdateIn, signal
    },
      options);
    }




export const getUpdateUserAdminMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserAdmin>>, TError,{userId: string;data: UserAdminUpdateIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserAdmin>>, TError,{userId: string;data: UserAdminUpdateIn}, TContext> => {

const mutationKey = ['updateUserAdmin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserAdmin>>, {userId: string;data: UserAdminUpdateIn}> = (props) => {
          const {userId,data} = props ?? {};

          return  updateUserAdmin(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserAdminMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserAdmin>>>
    export type UpdateUserAdminMutationBody = UserAdminUpdateIn
    export type UpdateUserAdminMutationError = unknown

    /**
 * @summary Update User Admin Endpoint
 */
export const useUpdateUserAdmin = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserAdmin>>, TError,{userId: string;data: UserAdminUpdateIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUserAdmin>>,
        TError,
        {userId: string;data: UserAdminUpdateIn},
        TContext
      > => {
      return useMutation(getUpdateUserAdminMutationOptions(options), queryClient);
    }
    /**
 * Admin sets another user's password directly (no old-password challenge).
 *
 * The privileged counterpart to self-service ``POST /auth/change-password``
 * (which requires the caller's current password). Gated INLINE on
 * ``users:edit`` -- the same permission that gates the sibling admin writes on
 * this router (bank details, department); this router uses
 * ``from __future__ import annotations``, which the ``@requires_permission``
 * decorator can't tolerate (see ``list_role_summaries``). Org-scope check, the
 * super-admin-target guard, session revocation, lockout clear, and the audit
 * write all live in the service.
 * @summary Reset User Password Admin Endpoint
 */
export const resetUserPasswordAdmin = (
    userId: string,
    adminResetPasswordIn: AdminResetPasswordIn,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<MessageOut>(
      {url: `/auth/users/${userId}/reset-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminResetPasswordIn, signal
    },
      options);
    }




export const getResetUserPasswordAdminMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetUserPasswordAdmin>>, TError,{userId: string;data: AdminResetPasswordIn}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resetUserPasswordAdmin>>, TError,{userId: string;data: AdminResetPasswordIn}, TContext> => {

const mutationKey = ['resetUserPasswordAdmin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetUserPasswordAdmin>>, {userId: string;data: AdminResetPasswordIn}> = (props) => {
          const {userId,data} = props ?? {};

          return  resetUserPasswordAdmin(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetUserPasswordAdminMutationResult = NonNullable<Awaited<ReturnType<typeof resetUserPasswordAdmin>>>
    export type ResetUserPasswordAdminMutationBody = AdminResetPasswordIn
    export type ResetUserPasswordAdminMutationError = unknown

    /**
 * @summary Reset User Password Admin Endpoint
 */
export const useResetUserPasswordAdmin = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetUserPasswordAdmin>>, TError,{userId: string;data: AdminResetPasswordIn}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetUserPasswordAdmin>>,
        TError,
        {userId: string;data: AdminResetPasswordIn},
        TContext
      > => {
      return useMutation(getResetUserPasswordAdminMutationOptions(options), queryClient);
    }
